import * as React from 'react';
import getLocationPhoto from '../utils/getLocationPhoto';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { LocationPersonaControlViewState } from '../data/schema/LocationPersonaControlViewState';
import { observer } from 'mobx-react';
import { Persona, PersonaPresence, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { trace } from 'owa-trace';

const assign = require('object-assign');

/**
 * props for the location persona control.
 * @param locationPersona: the persona control view state
 * @param size: the persona control size, this is passed to office-ui-fabric-react Persona control
 * @param showPersonaDetails: true if the contol show the persona text
 * @param className: a custom Css class passed to office-ui-fabric-react Persona control.
 */
export interface LocationPersonaControlProps {
    locationPersona: LocationPersonaControlViewState;
    size: PersonaSize;
    showPersonaDetails?: boolean;
    className?: string;
}

interface LocationPersonaControlState {
    blobUrl: string;
}

export type LocationBlobRequestStatus = 'pending' | 'failed' | 'success';

@observer
export class LocationPersonaControl extends React.Component<
    LocationPersonaControlProps,
    LocationPersonaControlState
> {
    private requestStatus: LocationBlobRequestStatus;

    constructor(props: LocationPersonaControlProps) {
        super(props);
        this.state = { blobUrl: null };
    }
    componentDidMount() {
        this.fetchPersonaPhoto(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps: LocationPersonaControlProps) {
        this.fetchPersonaPhoto(nextProps);
    }

    /**
     * fetches the location persona photo
     * @param props the address and display text of the location
     */
    fetchPersonaPhoto(props: LocationPersonaControlProps) {
        if (
            props.locationPersona.postalAddress &&
            props.locationPersona.postalAddress.Latitude &&
            props.locationPersona.postalAddress.Longitude &&
            !isNullOrWhiteSpace(props.locationPersona.displayName) &&
            !this.state.blobUrl &&
            this.requestStatus != 'pending' &&
            this.requestStatus != 'failed'
        ) {
            this.requestStatus = 'pending';
            getLocationPhoto(props.locationPersona, this.onCompleteDownload);
        }
    }

    onCompleteDownload = (blobUrl: string) => {
        this.setState({
            blobUrl: blobUrl,
        });
        if (!blobUrl) {
            this.requestStatus = 'failed';
            // Log that we failed to fetch the location photo. Not logging url for now, will add if we see enough number of errors
            trace.warn('getLocationPhoto.downloadLocationPhoto failed');
        } else {
            this.requestStatus = 'success';
        }
    };

    render() {
        let { locationPersona, className, size, showPersonaDetails } = this.props;

        if (locationPersona) {
            let photoDisplayProps: any = {};
            if (!isNullOrWhiteSpace(this.state.blobUrl)) {
                assign(photoDisplayProps, {
                    imageUrl: this.state.blobUrl,
                    imageShouldFadeIn: false,
                });
            } else {
                assign(photoDisplayProps, {
                    imageInitials: locationPersona.initials,
                    initialsColor: locationPersona.textBoyColor,
                });
            }

            return (
                <Persona
                    className={className}
                    presence={PersonaPresence.none}
                    hidePersonaDetails={!showPersonaDetails}
                    size={size}
                    text={locationPersona.displayName}
                    secondaryText={locationPersona.displayAddress}
                    {...photoDisplayProps}
                />
            );
        }
        return null;
    }
}
